import { render } from "./Textbox.vue?vue&type=template&id=4742de3a"
import script from "./Textbox.vue?vue&type=script&lang=js"
export * from "./Textbox.vue?vue&type=script&lang=js"

import exportComponent from "C:\\VS2022\\kirchenbote-online-2022_01\\MD.RMP.KirchenboteOnline.Umb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/multiForms/fieldTypes/Textbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4742de3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4742de3a', __exports__)) {
    api.reload('4742de3a', __exports__)
  }
  
  module.hot.accept("./Textbox.vue?vue&type=template&id=4742de3a", () => {
    api.rerender('4742de3a', render)
  })

}


export default __exports__